<template>
  <a-menu theme="dark" mode="inline" :default-selected-keys="['1']" @click="menuClick">
    <a-menu-item v-for="item in menuList" :key="item.key">
      <a-icon :type="item.icon" />
      <span>{{item.name}}</span>
    </a-menu-item>
  </a-menu>
</template>

<script>
export default {
  data(){
    return {
      menuList: [
        {
          key: 1,
          name: "账单管理",
          router: "/pay/unpaidList",
          icon: 'account-book'
        },
        {
          key: 2,
          name: "缴费列表",
          router: "/pay/payList",
          icon: 'container'
        },
        {
          key: 3,
          name: "费用预存",
          router: "/expenseDeposit/list",
          icon: 'money-collect'
        },
        // {
        //   key: 4,
        //   name: "开具发票",
        //   router: "/invoice/list",
        //   icon: 'book',
        // },
        // {
        //   key: 5,
        //   name: "发票历史",
        //   router: "/invoice/history",
        //   icon: 'file-search'
        // },
      ]
    }
  },
  methods:{
    menuClick(menu){
      let el = this.menuList.find(item=>{
        return item.key === menu.key
      })
      this.$router.push({
        path: el.router
      })
    }
  }
}
</script>

<style scoped>

</style>